import React, { ReactNode } from "react";
import { Link } from "react-router";
import { useLoosePermissionCheck } from "capitalrx-shell";
import { batchTestClaim, medicalTestClaim } from "@/App/constants/permissions";
import PageContentLayout from "../PageContent";

interface Props {
  children: ReactNode;
  selected?: string;
}

const TestClaimLayout: React.FC<Props> = (props: Props) => {
  const { children, selected = "leftToggle" } = props;
  const sectionTitle = "Test Claim Adjudication";

  let showExtraContent = false;
  let extraContent;

  if (useLoosePermissionCheck(medicalTestClaim)) {
    showExtraContent = true;
    extraContent = (
      <Link to="/module/test_adjudication/medical-single-test-claim" style={{ marginRight: "8px" }}>Medical Test Claims</Link>
    );
  }

  return (
    <PageContentLayout
      showToggleButton={useLoosePermissionCheck(batchTestClaim)}
      leftToggleURL="/test-claim"
      rightToggleURL="/test-claim/batch"
      leftToggleContent="Single"
      rightToggleContent="Batch"
      leftToggleSelected={selected === "leftToggle"}
      rightToggleSelected={selected === "rightToggle"}
      title={sectionTitle}
      pageContentHeaderClassName="test-claim-page-header"
      extraContent={extraContent}
      showExtraContent={showExtraContent}
    >
      {children}
    </PageContentLayout>
  );
};

export default TestClaimLayout;
